module.exports = __webpack_public_path__ + "img/book_with_hand.0f7783be.png";